// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "" + {"180":"video","303":"widget","495":"feed"}[chunkId] + "." + {"180":"1c5143cf1b714eb848a7","303":"0d62f652da6f68deb257","495":"9ab94051f0272d317128"}[chunkId] + ".js";
};